import {PromotionStatus, QueryPromotionStatusArgs} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"
import promotionStatus, {promotionStatusKey} from "./services/queries/promotionStatus"

export const usePromotionStatus = createUseQuery<PromotionStatus, QueryPromotionStatusArgs>(promotionStatus, {key: promotionStatusKey})
